import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import AppointmentList from "../partials/list/AppointmentList";
import { BoxContainer } from '../layouts/Theme';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useConsumerAppointments } from '../hooks/query/useConsumerAppointments';
export default function Appointments(props) {
    var _a, _b;
    const { t } = useI18N();
    const flow = useFlow();
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Afspraken');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    const appointmentsQuery = useConsumerAppointments();
    // the two lists are split by the API, so this view only decides which of the three states of
    // the query it is in: still loading, failed, or the appointments themselves
    const result = appointmentsQuery.data;
    const failed = ((_a = result === null || result === void 0 ? void 0 : result.status) === null || _a === void 0 ? void 0 : _a.status) === 'failed';
    const appointments = failed ? undefined : (_b = result === null || result === void 0 ? void 0 : result.result) === null || _b === void 0 ? void 0 : _b.item;
    return (_jsxs(BoxContainer, { children: [appointmentsQuery.isFetching && !result && (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', my: 4 }, children: _jsx(CircularProgress, {}) })), (appointmentsQuery.isError || failed) && (_jsx(Alert, { sx: { my: 1 }, severity: "error", children: failed ? t(result.status.message) : t('Je afspraken konden niet worden opgehaald.') })), appointments && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", children: t('Toekomstige afspraken') }), _jsx(AppointmentList, { type: "future", appointments: appointments.future, company: appointments.company }), _jsx(Typography, { variant: "h6", children: t('Afspraken in het verleden') }), _jsx(AppointmentList, { type: "past", appointments: appointments.past, company: appointments.company })] }))] }));
}
